const webcast_en = require('./webcast.json')
export default webcast_en